import restApi from "@plannel/services/utils/rest-api";

const user = JSON.parse(localStorage.getItem("user"));

const getTableInfo = () => {
  return restApi.get("/data/schema/tables");
}

const getValidation = () => {
  return restApi.get("/data/schema/validation");
}

const getTableStatus = params => {
  return restApi.get("/data/table/status", { params });
}

const exportFile = formData => {
  return fetch(`/data/export?${formData}`, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      "x-tenant-id": user.tenantId,
      Authorization: `${user.type} ${user.accessToken}`
    }
  });
}

const importFile = formData => {
  return restApi.post("/data/import/files", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

const truncate  = params => {
  return restApi.delete("/data/truncate", { params });
}

const deleteTableData = (params) => {
  return restApi.delete("/data/delete", { params });
}

const dataValidation = validation => {
  return restApi.post("/data/validation", JSON.stringify(validation));
}

const syncValidation = validationTitle => {
  return restApi.post("/data/validation/sync", null, {
    params: { VALIDATION_TITLE: validationTitle }
  });
}

const dataLoadValidationService = {
  getTableInfo,
  getValidation,
  getTableStatus,
  exportFile,
  importFile,
  truncate,
  deleteTableData,
  dataValidation,
  syncValidation
};

export default dataLoadValidationService;